import * as THREE from "three";

// [설정/스피어] 스피어의 이동 경로
export const memberSphereCurves = [
  // // 좌측 구의 동선
  // new THREE.CatmullRomCurve3([
  //   new THREE.Vector3(-1, -12, -10),
  //   new THREE.Vector3(-1, -3, -0),
  //   new THREE.Vector3(0, 1, 25),
  //   new THREE.Vector3(7, 1, 30),
  //   new THREE.Vector3(5, 0, 35),
  // ]),
  // // 중앙 구의 동선
  // new THREE.CatmullRomCurve3([
  //   new THREE.Vector3(1, -15, -10),
  //   new THREE.Vector3(1, -3, -0),
  //   new THREE.Vector3(1, 0.8, 25),
  //   new THREE.Vector3(0, -1.5, 30),
  //   new THREE.Vector3(0, 0, 35),
  // ]),
  // // 우측 구의 동선
  // new THREE.CatmullRomCurve3([
  //   new THREE.Vector3(3, -17, -15),
  //   new THREE.Vector3(4, -1, -5),
  //   new THREE.Vector3(5.5, -1, 25),
  //   new THREE.Vector3(1, 0, 30),
  //   new THREE.Vector3(0, 0, 35),
  // ]),

  // 좌측 구의 동선
  new THREE.CatmullRomCurve3([
    new THREE.Vector3(-1, -12,20),
    new THREE.Vector3(-1, -2.5, 5),
    new THREE.Vector3(0, 1, 25),
    new THREE.Vector3(7, 1, 30),
    new THREE.Vector3(5, 0, 35),
  ]),
  // 중앙 구의 동선
  new THREE.CatmullRomCurve3([
    new THREE.Vector3(1, -15, 20),
    new THREE.Vector3(1.5, -2, 5),
    new THREE.Vector3(1, 0.8, 25),
    new THREE.Vector3(0, -1.6, 30),
    new THREE.Vector3(0, -1, 35),
  ]),
  // 우측 구의 동선
  new THREE.CatmullRomCurve3([
    new THREE.Vector3(3, -17, 20),
    new THREE.Vector3(5, 0, 0),
    new THREE.Vector3(5.5, -0.5, 25),
    new THREE.Vector3(1, 0, 30),
    new THREE.Vector3(5, 0, 35),
  ]),

    // // 좌측 구의 동선
    // new THREE.CatmullRomCurve3([
    //   new THREE.Vector3(0, -3, 20),
    //   new THREE.Vector3(-0.5, -0.3, 5),
    //   new THREE.Vector3(-1.5, 0.1, 15),
    //   new THREE.Vector3(0, 0, 37),
    // ]),
    // // 중앙 구의 동선
    // new THREE.CatmullRomCurve3([
    //   new THREE.Vector3(-0.5, -2.5, 19),
    //   new THREE.Vector3(3.4, 0, 4),
    //   new THREE.Vector3(1.9, 0.2, 10),
    //   new THREE.Vector3(-1, 0, 34),
    // ]),
    // // 우측 구의 동선
    // new THREE.CatmullRomCurve3([
    //   new THREE.Vector3(-0.5, -2, 18),
    //   new THREE.Vector3(7, 0, 2),
    //   new THREE.Vector3(7, 0.3, 3),
    //   new THREE.Vector3(-3, 0, 32),
    // ]),
];
